var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVolumePassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 27.6334V25.5667C21.3222 24.9445 23.0833 23.75 24.45 21.9834C25.8167 20.2167 26.5 18.2112 26.5 15.9667C26.5 13.7223 25.8222 11.7112 24.4667 9.93338C23.1111 8.1556 21.3444 6.96672 19.1667 6.36672V4.30005C21.9222 4.92227 24.1667 6.31672 25.9 8.48338C27.6333 10.65 28.5 13.1445 28.5 15.9667C28.5 18.7889 27.6333 21.2834 25.9 23.45C24.1667 25.6167 21.9222 27.0112 19.1667 27.6334ZM4.5 20V12H9.83333L16.5 5.33338V26.6667L9.83333 20H4.5ZM18.5 21.6V10.3667C19.7222 10.7445 20.6944 11.4556 21.4167 12.5C22.1389 13.5445 22.5 14.7112 22.5 16C22.5 17.2667 22.1333 18.4223 21.4 19.4667C20.6667 20.5112 19.7 21.2223 18.5 21.6Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolumePassive);
export default __webpack_public_path__ + "static/media/icon-volume-passive.30266ce741e39a80724842eefc58e913.svg";
export { ForwardRef as ReactComponent };